import { DAY_IN_S, MINUTE_IN_S } from "@shared/time-constants";
import { AuthSessionType } from "./auth-types";

export const AUTH_SECRET_NAME = "AUTH_SECRET";
export const COOKIE_NAME = "refresh-token";
export const REFRESH_TOKEN_MAX_AGE = 30 * DAY_IN_S;
export const ACCESS_TOKEN_MAX_AGE = MINUTE_IN_S;
export const ACCESS_TOKEN_EXPIRY_THRESHOLD = 10;
export const API_PATH_PREFIX = "/api/v1/auth";
export const API_PATHS = {
  CONCIERGE_LOGIN: "/concierge/login",
  CONCIERGE_LOGOUT: "/concierge/logout",
  CONCIERGE_NEW_SESSION: "/concierge/new-session",
  CONCIERGE_PAIRING: "/concierge/pairing",
};
export const VALID_DEVICE_SESSION_TYPES = [AuthSessionType.CONCIERGE, AuthSessionType.KIOSK];
